import { DesktopSidebar } from './components/DesktopSidebar';
import { DesktopSidebarWithSnowflakeWrapper } from './styled';
import { FadingSnowflake } from './components/FadingSnowflake';

interface DesktopSidebarWithSnowflakeProps {
  selected: string;
  handleClick?: (section: string) => void;
  keepSnowflakePinned?: boolean;
}

export const DesktopSidebarWithSnowflake = ({
  selected,
  handleClick,
  keepSnowflakePinned,
}: DesktopSidebarWithSnowflakeProps) => {
  return (
    <DesktopSidebarWithSnowflakeWrapper data-cy-id="desktop-sidebar-snowflake-wrapper">
      <FadingSnowflake
        onClick={handleClick}
        keepSnowflakePinned={keepSnowflakePinned}
      />
      <div>
        <DesktopSidebar selected={selected} handleClick={handleClick} />
      </div>
    </DesktopSidebarWithSnowflakeWrapper>
  );
};
